import AuthConstants from '../constants/AuthConstants';
import { selectCurrentAccount } from '../selectors/AuthSelector';
import composeFailureMessaging from '../helpers/messaging/composeFailureMessaging';
import composeGlobalFailureMessaging from '../helpers/messaging/composeGlobalFailureMessaging';

export default function authMiddleware(store) {
  return next => action => {
    const { middlewareData } = action;
    const auth = store.getState().get('auth');

    // Check if the current action requires authentication,
    // and then dispatch an OPEN_LOGIN_DIALOG action if unauthenticated.
    if (
      __CLIENT__ &&
      middlewareData &&
      (middlewareData.authRequired || middlewareData.accountRequired) &&
      !auth.get('currentUserId')
    ) {
      return next({
        type: AuthConstants.OPEN_LOGIN_DIALOG,
        payload: { postLoginAction: action }
      });
    }

    // Check if the current action requires a library account, and then
    // dispatch a REQUIRES_LIBRARY_ACCOUNT action if there no account.
    if (__CLIENT__ && middlewareData && middlewareData.accountRequired && !selectCurrentAccount(store.getState())) {
      const err = { classification: 'requiresLibraryAccount' };
      const payload = action.payload || {};
      const messagingId = action.messagingId || payload.id || action.id; // TODO: only support action.messagingId

      return next({
        type: AuthConstants.REQUIRES_LIBRARY_ACCOUNT,
        id: payload.id || action.id,
        messaging: messagingId ? composeFailureMessaging(messagingId, err) : composeGlobalFailureMessaging(err)
      });
    }

    return next(action);
  };
}
